import classNames from "classnames";
import { useEffect, useRef } from "react";

import { LISCaseList } from "pwapi";

// @ts-ignore (it's js not ts)
import DATAMatrix from "datamatrix.js";
import { labelForBlock } from "util/blockUtils";
import { truncatePatientName } from "util/patientUtils";

// This is a legacy barcode for Leica IP-C Cassette Printers
// ... that we don't use. They had these at Bayshore and PPS
// Leaving this in case we need it again in the future.

const CassetteBarcodeIPC = ({
  id,
  printCase,
}: {
  id: number;
  printCase: LISCaseList;
}) => {
  const block = printCase?.blocks.find((b) => b.id === id);

  const patientName = truncatePatientName(printCase?.patient);
  const datamatrixRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    const datamatrixSVG = DATAMatrix({
      msg: `block-${block?.id}`,
      dim: 16,
      rct: 0,
      pad: 0,
      vrb: 0,
    });
    datamatrixRef.current?.replaceWith(datamatrixSVG);
  }, [block?.id]);

  return block ? (
    <div
      className={classNames(
        "DecoratedBarcode",
        "DecoratedBarcode--cassette-ipc"
      )}
    >
      <div className="Barcode CassetteBarcodeIPC">
        <figure>
          <div className="Barcode__qr">
            <svg ref={datamatrixRef} />
          </div>
        </figure>

        <div>
          <p className="Barcode__label">
            <span>{printCase?.accession}</span>{" "}
            <strong>{labelForBlock(block, printCase)}</strong>
          </p>{" "}
          <p className="Barcode__accession">
            <span>{patientName}</span>
          </p>
        </div>
      </div>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            @page { margin: 0; }
          `,
        }}
      />
    </div>
  ) : null;
};

export default CassetteBarcodeIPC;
